import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

const TgStarIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.XXXXL}
      svgProps={{
        viewBox: '0 0 160 160'
      }}
      {...props}
    >
      <g clipPath="url(#clip0_8688_2583)">
        <mask
          id="mask0_8688_2583"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="160"
          height="160"
        >
          <path d="M160 0H0V160H160V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_8688_2583)">
          <mask
            id="mask1_8688_2583"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="160"
            height="160"
          >
            <path d="M0 0H160V160H0V0Z" fill="white" />
          </mask>
          <g mask="url(#mask1_8688_2583)">
            <path
              d="M54.5663 48.9733L72.3895 13.4662C74.4503 9.37244 79.4353 7.72937 83.5012 9.79017C85.0885 10.5978 86.3696 11.9067 87.1772 13.5219L104.026 47.7758C105.39 50.5885 108.092 52.4823 111.183 52.8443L146.411 57.0773C151.201 57.6621 154.627 62.0344 154.07 66.8522C153.819 68.8295 152.928 70.6675 151.508 72.0599L123.631 99.5466C122.489 100.661 121.96 102.22 122.155 103.807L126.806 140.902C127.474 146.221 123.715 151.067 118.423 151.735C116.418 151.986 114.413 151.624 112.631 150.649L83.1948 134.552C81.0505 133.383 78.4884 133.355 76.344 134.469L45.8218 150.12C41.5331 152.32 36.2976 150.593 34.0975 146.277C33.2621 144.662 32.9836 142.851 33.2342 141.069L35.6571 124.026C36.8546 115.699 42.0066 108.458 49.47 104.643L83.3341 87.3489C84.2252 86.9033 84.5873 85.7893 84.1417 84.8703C83.7797 84.1741 83.0277 83.7564 82.248 83.8678L40.8091 89.8274C34.4874 90.7186 28.0822 88.9362 23.0973 84.8703L9.31217 73.6194C5.3855 70.4168 4.74498 64.5686 7.94759 60.6141C9.45142 58.7761 11.5958 57.5786 13.9351 57.2722L49.3029 52.7329C51.5587 52.4266 53.5359 51.0341 54.5663 48.9733Z"
              fill="url(#paint0_linear_8688_2583)"
            />
            <path
              d="M85.924 19.7882C82.3315 18.9806 78.5162 20.7072 76.7896 24.1605L58.9386 59.6676C57.9082 61.7284 55.9588 63.1208 53.6752 63.4272L18.3073 67.9944C16.0237 68.3007 13.9351 69.4146 12.4591 71.1691L25.548 81.863C29.6696 85.2327 35.0165 86.7087 40.2799 85.9568L81.691 80.025C84.1417 79.6908 86.5367 80.9162 87.6228 83.1162C89.0431 85.9289 87.9291 89.3822 85.1164 90.8303L74.3111 96.3444L86.6202 94.562C87.4 94.4506 88.1798 94.8684 88.5139 95.5646C88.9874 96.4836 88.5975 97.5976 87.7063 98.0431L53.8423 115.337C46.3788 119.152 41.2268 126.393 40.0293 134.72L38.4419 145.776C39.8901 147.224 42.1737 147.614 44.0674 146.639L74.5339 130.988C77.8479 129.289 81.7746 129.345 85.0328 131.127L114.469 147.224C115.527 147.809 116.753 148.032 117.95 147.892C121.069 147.502 123.325 144.606 122.935 141.404L118.312 104.281C117.978 101.496 118.925 98.7393 120.902 96.7899L148.779 69.3033C149.252 68.8298 149.614 68.2728 149.865 67.6602L115.555 63.5386C112.464 63.1765 109.79 61.255 108.398 58.4701L107.061 55.7131C104.248 54.4877 101.937 52.3155 100.545 49.5028L85.924 19.7882Z"
              fill="url(#paint1_linear_8688_2583)"
            />
            <path
              d="M85.2556 6.30937C79.2403 3.27386 71.944 5.6967 68.9363 11.712L51.0853 47.247C50.6397 48.1382 49.7764 48.7508 48.8017 48.8622L13.4338 53.4294C10.0919 53.8471 7.02858 55.5738 4.91208 58.1915C0.372738 63.817 1.23605 72.0602 6.83364 76.6274L20.6466 87.9061C26.467 92.6404 33.9583 94.7291 41.3661 93.6708L70.6351 89.4657L47.6877 101.19C39.0825 105.59 33.1785 113.889 31.8139 123.469L29.3633 140.512C29.0012 143.102 29.419 145.72 30.6165 148.059C33.7634 154.27 41.3939 156.748 47.6042 153.573L78.0985 137.922C79.1011 137.393 80.2986 137.421 81.3011 137.978L110.737 154.047C113.216 155.411 116.084 155.968 118.897 155.606C126.333 154.66 131.568 147.837 130.649 140.429L126.026 103.306C125.97 102.944 126.11 102.555 126.36 102.304L154.237 74.8172C156.27 72.7843 157.579 70.1386 157.913 67.2981C158.721 60.3637 153.819 54.0699 146.885 53.2345L111.628 49.0015C109.874 48.8065 108.314 47.6926 107.507 46.0773L90.6861 11.7956C89.5165 9.42842 87.5949 7.50686 85.2556 6.30937ZM75.8706 15.1931C76.9567 13.0209 79.6024 12.1576 81.7467 13.2437C82.5822 13.6614 83.2784 14.3855 83.6961 15.2488L100.545 49.5027C102.494 53.4851 106.309 56.1864 110.709 56.7156L145.966 60.9486C148.611 61.2549 150.505 63.6777 150.199 66.3791C150.06 67.493 149.558 68.5234 148.779 69.3032L120.902 96.7899C118.925 98.7393 117.978 101.496 118.312 104.281L122.935 141.404C123.325 144.606 121.069 147.502 117.95 147.892C116.753 148.032 115.527 147.809 114.469 147.224L85.0329 131.127C81.7746 129.345 77.8479 129.317 74.5339 131.016L44.0395 146.667C41.6724 147.864 38.7761 146.918 37.5508 144.523C37.1052 143.631 36.9381 142.601 37.0774 141.598L39.5002 124.583C40.5027 117.509 44.9028 111.355 51.2245 108.124L85.0886 90.8302C87.9291 89.3821 89.0431 85.9289 87.6228 83.1162C86.5088 80.9161 84.1417 79.6908 81.691 80.0249L40.2521 85.9567C34.9887 86.7086 29.6696 85.2327 25.548 81.863L11.7629 70.5842C9.47927 68.7184 9.11724 65.3487 10.9831 63.0651C11.8464 62.0068 13.0718 61.3106 14.4085 61.1435L49.7764 56.5763C53.341 56.1307 56.4322 53.9307 58.0474 50.7281L75.8706 15.1931Z"
              fill="url(#paint2_linear_8688_2583)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_8688_2583"
          x1="80.0201"
          y1="8.89901"
          x2="80.0201"
          y2="151.819"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF0C2" />
          <stop offset="1" stopColor="#FFEBBA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8688_2583"
          x1="81.1619"
          y1="19.5933"
          x2="120.373"
          y2="147.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD147" />
          <stop offset="1" stopColor="#FFB526" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8688_2583"
          x1="80.0201"
          y1="5.00048"
          x2="114.413"
          y2="155.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E58F0D" />
          <stop offset="1" stopColor="#EB7814" />
        </linearGradient>
        <clipPath id="clip0_8688_2583">
          <rect width="160" height="160" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

export default TgStarIcon;
